import React from 'react';
import { Select } from 'antd';
import {
  AddedSection,
  AddedAttribute,
  AddedAttributeType,
} from 'pages/UserPage/components/MiddlePane/types';
import { DERIVED_ATTRIBUTE_REGEX } from 'common/constants/constants';
import { parseAttributeToDisplayText } from '../../../../utils/displayAttributes';
import { updateAddedValue, updateValue } from '../../../updateAttributeValueUtils';
import styles from '../AttributeTypeEditField.module.scss';
import AttributeTag from './AttributeTag';

interface Props {
  addedSections: AddedSection[];
  attributeTypeName: string;
  attributeValuesForDisplay: string[];
  attributesForEdit: AddedAttribute[];
  editDerivedAttributeErrorModal: () => void;
  section: AddedSection;
  setAddedSections: (addedSections: AddedSection[]) => void;
  setUserAttributeTypes: (userAttributeTypes: AddedAttributeType[]) => void;
  userAttributeTypes: AddedAttributeType[];
}

const NonSingletonEditField = ({
  addedSections,
  attributeTypeName,
  attributeValuesForDisplay,
  attributesForEdit,
  editDerivedAttributeErrorModal,
  section,
  setAddedSections,
  setUserAttributeTypes,
  userAttributeTypes,
}: Props) => (
  <Select
    className={styles.editField}
    mode="tags"
    onChange={(input: (string | number)[]) => {
      const removedTag = attributesForEdit?.filter(attribute => {
        const displayAttribute = parseAttributeToDisplayText(attribute);
        return !input.includes(displayAttribute);
      });

      if (removedTag.length !== 0 && removedTag[0].is_derived) {
        editDerivedAttributeErrorModal();
        return;
      }

      const filteredVal = input.filter(
        v => typeof v === 'string' && !(v as string).match(DERIVED_ATTRIBUTE_REGEX)
      );
      if (section.addedSection) {
        updateAddedValue(
          section.name,
          attributeTypeName,
          filteredVal as string[],
          addedSections,
          userAttributeTypes,
          setUserAttributeTypes,
          setAddedSections
        );
      } else {
        const attrs: AddedAttribute[] = filteredVal.map(value => ({ value }));
        updateValue(
          attributeTypeName,
          attrs,
          userAttributeTypes,
          setUserAttributeTypes
        );
      }
    }}
    // unfortunately, we need to go against recommendation in order to reuse
    // the AttributeTag component here
    // eslint-disable-next-line react/no-unstable-nested-components
    tagRender={props => (
      <AttributeTag
        {...props}
        attributeTypeName={attributeTypeName}
        attributesForEdit={attributesForEdit}
        isUsingDisplayValues={false}
        setUserAttributeTypes={setUserAttributeTypes}
        userAttributeTypes={userAttributeTypes}
      />
    )}
    value={attributeValuesForDisplay}
  />
);

export default NonSingletonEditField;
